module.exports = __webpack_public_path__ + "img/2_2-commerciale-stadio-2.b3405496.png";